import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const MILESTONES_RECAP_QUERY_KEY = ["milestones", "recap"] as const;
export const MILESTONES_QUERY_KEY = ["milestones"] as const;
export const CLAIM_MILESTONE_MUTATION_KEY = ["milestones", "claim"] as const;

// Direct types from API responses
export type MilestonesRecapResponse = InferResponseType<
  typeof client.milestones.recap.$get,
  200
>;

export type MilestonesResponse = InferResponseType<
  typeof client.milestones.$get,
  200
>;

export type TrackType = keyof MilestonesResponse;
export type MilestoneType = MilestonesResponse[TrackType];
export type Milestone = MilestoneType["milestones"][number];
export type MilestoneStatus = Milestone["status"];

// Claim milestone types
export type ClaimMilestoneRequest = InferRequestType<
  typeof client.milestones.claim.$post
>["json"];

export type ClaimMilestoneResponse = InferResponseType<
  typeof client.milestones.claim.$post,
  200
>;
